//Quiz for developing
import testing_quiz_only from "./quiz/testing_quiz_only";
import testing_with_autobooking from "./quiz/testing_with_autobooking";
import testing_cover_question from "./quiz/testingCoverQuestion";
//Indonesia
import indonesia_purple from "./quiz/indonesia/purple";
import indonesia_green from "./quiz/indonesia/green";
import indonesia_yellow from "./quiz/indonesia/yellow";
import indonezia_v1 from "./quiz/indonesia/v1";
import indo_dc_1 from "./quiz/indonesia/dc_1";
import indo_steps_dc_1 from "./quiz/indonesia/steps_dc_1";
import indo_steps_dc_2 from "./quiz/indonesia/steps_dc_2";
import indo_steps_dc_3 from "./quiz/indonesia/steps_dc_3";
import indo_coding_1 from "./quiz/indonesia/coding_1";
import indo_coding_2 from "./quiz/indonesia/coding_2";
import indo_coding_2_eng from "./quiz/indonesia/coding_2_eng";
import indo_zp_1 from "./quiz/indonesia/zp_1";
import indo_base_1 from "./quiz/indonesia/base_1";
import indo_base_1_gcc from "./quiz/indonesia/base_1_gcc";
import indo_bf_dc from "./quiz/indonesia/black_friday_dc";
import indo_crossed_price_1 from "./quiz/indonesia/crossed_price_1";
import indo_leadmagnet_1 from "./quiz/indonesia/leadmagnet_1";
import indo_dc_comp_1 from "./quiz/indonesia/dc_comp_1";
import indo_dc_base_bonus from "./quiz/indonesia/dc_base_bonus";
import indo_new_year from "./quiz/indonesia/new_year";
import indo_bonus_coding_3 from "./quiz/indonesia/bonus_coding_3";
import indo_certificate_dc from "./quiz/indonesia/certificate_dc";
import indo_coding_4 from "./quiz/indonesia/coding_4";
import indo_give_away from "./quiz/indonesia/give_away";
import indo_computer_literacy from "./quiz/indonesia/computer_literacy";
import indo_without_questions from "./quiz/indonesia/without_questions";
import indo_course from "./quiz/indonesia/course";
import indo_social_proof from "./quiz/indonesia/social_proof";
import indo_crossed_price_2 from "./quiz/indonesia/crossed_price_2";
import indo_coding_2_2 from "./quiz/indonesia/coding_2_2";
import indo_v2 from "./quiz/indonesia/v2";
import indo_custom_start_screen from "./quiz/indonesia/custom_start_screen";
import indo_v3 from "./quiz/indonesia/v3";
import indo_limited_offer from "./quiz/indonesia/limited_offer";
import indo_custom_profi from "./quiz/indonesia/custom_profi";
import indo_free_course from "./quiz/indonesia/free_course";
import indo_free_course_dc from "./quiz/indonesia/free_course_dc";
import indo_teens from "./quiz/indonesia/teens";
import indo_early_math from "./quiz/indonesia/early_math";
import indo_graphic_design from "./quiz/indonesia/graphic_design";
import math_freetc_indonesia from "./quiz/indonesia/math_freetc_indonesia";
import math_freetc_indonesia_gcc from "./quiz/indonesia/math_freetc_indonesia_gcc";
import math_freetc_indonesia_new from "./quiz/indonesia/math_freetc_indonesia_new";
import math_freetc_indonesia_new_checkbox from "./quiz/indonesia/math_freetc_indonesia_new_checkbox";
import math_freetc_indonesia_new_intent from "./quiz/indonesia/math_freetc_indonesia_new_intent";
import indo_fwd from "./quiz/indonesia/indo_fwd";
import math_freetc_indonesia_pix from "./quiz/indonesia/math_freetc_indonesia_pix";
import indonesia_longquiz_dev from "./quiz/indonesia/indonesia_longquiz_dev";
import indonesia_longquiz_rob from "./quiz/indonesia/indonesia_longquiz_rob";
import indonesia_course from "./quiz/indonesia/indo_course";
import indonesia_offer from "./quiz/indonesia/indonesia_offer";
import in_fwd from "./quiz/indonesia/in_fwd";
import indonesia_longquiz_fwd from "./quiz/indonesia/indonesia_longquiz_fwd";
import indonesia_fwd from "./quiz/indonesia/indonesia_fwd";
import indonesia_video from "./quiz/indonesia/indonesia_video";
import indo_profit from "./quiz/indonesia/indo_profit";
import indo_profit_gcc from "./quiz/indonesia/indo_profit_gcc";
//Malaysia
import my_base from "./quiz/malaysia/my_base";
import my_fwd from "./quiz/malaysia/my_fwd";
//Turkey
import tr_roblox from "./quiz/turkey/tr_roblox";
import turkey_1 from "./quiz/turkey/v_1";
import turkey_math from "./quiz/turkey/math";
import turkey_dc_2 from "./quiz/turkey/dc_2";
import turkey_dc_1 from "./quiz/turkey/dc_1";
import turkey_steps_1 from "./quiz/turkey/steps_1";
import turkey_bf_steps_1 from "./quiz/turkey/bf_steps_1";
import turkey_steps_28_11 from "./quiz/turkey/steps_28_11";
import turkey_crossed_1 from "./quiz/turkey/crossed_1";
import turkey_bloggers_1 from "./quiz/turkey/bloggers_1";
import turkey_coding_steps from "./quiz/turkey/coding_steps";
import turkey_new_year_steps from "./quiz/turkey/new_year_steps";
import turkey_coding_steps_new from "./quiz/turkey/coding_122022";
import turkey_bonus_steps_1 from "./quiz/turkey/bonus_steps_1";
import turkey_universal from "./quiz/turkey/universal";
import turkey_gaming from "./quiz/turkey/gaming";
import turkey_social_proof_steps from "./quiz/turkey/social_proof_steps";
import turkey_capi_1 from "./quiz/turkey/capi_1";
import turkey_steps_bonus_picture from "./quiz/turkey/steps_bonus_picture";
import turkey_bloggers_2 from "./quiz/turkey/bloggers_2";
import turkey_coding_steps_2 from "./quiz/turkey/coding_steps_2";
import turkey_steps_2 from "./quiz/turkey/steps_2";
import turkey_customized_lp from "./quiz/turkey/customized_lp";
import turkey_customized_lp_age from "./quiz/turkey/customized_lp_age";
import turkey_teenagers from "./quiz/turkey/teenagers";
import turkey_limited_offer from "./quiz/turkey/limited_offer";
import turkey_b2b from "./quiz/turkey/b2b";
import turkey_softtech from "./quiz/turkey/b2b_softtech";
import turkey_screening_lesson from "./quiz/turkey/screening_lesson";
import turkey_free_marathon from "./quiz/turkey/free_marathon";
import turkey_gamedev_free_course from "./quiz/turkey/gamedev_free_course";
import turkey_free_course_social_proof from "./quiz/turkey/free_course_social_proof";
import turkey_free_course from "./quiz/turkey/free_course";
import turkey_parent_or_child from "./quiz/turkey/parent_or_child";
import turkey_europe from "./quiz/turkey/europe";
import turkey_live_free_course from "./quiz/turkey/live_free_course";
import turkey_b2b_ako from "./quiz/turkey/b2b_ako";
import turkey_b2b_bil_kurs from "./quiz/turkey/b2b_bil_kurs";
import turkey_gamedev_free_course_2 from "./quiz/turkey/gamedev_free_course_2";
import turkey_b2b_kocailem from "./quiz/turkey/b2b_kocailem";
import turkey_b2b_isbankasi from "./quiz/turkey/b2b_isbankasi";
import turkey_b2b_lc_waikiki from "./quiz/turkey/b2b_lc_waikiki";
import turkey_b2b_aguniversity from "./quiz/turkey/b2b_aguniversity";
import turkey_first_money_in_it from "./quiz/turkey/first_money_in_it";
import turkey_math_active from "./quiz/turkey/math_active";
import turkey_math_active2 from "./quiz/turkey/math_active_2";
import softtech_math from "./quiz/turkey/math_active_softtech"
import turkey_socialproof from "./quiz/turkey/socialproof";
import turkey_supermega_social_proof from "./quiz/turkey/supermega_social_proof";
import turkey_b2b_girne_college from "./quiz/turkey/b2b_girne_college";
import turkey_b2b_savdes from "./quiz/turkey/b2b_savdes";
import turkey_one_year_gift from "./quiz/turkey/one_year_gift";
import turkey_one_year_gift_2 from "./quiz/turkey/one_year_gift_2";
import turkey_free_course_2 from "./quiz/turkey/free_course_2";
import turkey_coding_steps2 from "./quiz/turkey/coding_steps2";
import turkey_mentorship from "./quiz/turkey/mentorship";
import turkey_webinar from "./quiz/turkey/webinar";
import turkey_scoring from "./quiz/turkey/turkey_scoring";
import tr_scoring1 from "./quiz/turkey/tr_scoring1";
import tr_scoring2 from "./quiz/turkey/tr_scoring2";
import tr_math_scoring1 from "./quiz/turkey/tr_math_scoring1";
import latam_scoring1 from "./quiz/latam/latam_scoring1";
import lead_scor from "./quiz/latam/lead_scor";
import lead_no_scor from "./quiz/latam/lead_no_scor";
import lead_scor_1 from "./quiz/latam/lead_scor_1";
import lead_no_scor_2 from "./quiz/latam/lead_no_scor_2";
import latam_scoring2 from "./quiz/latam/latam_scoring2";
import latam_scoring3 from "./quiz/latam/latam_scoring3";
import latam_scoring12 from "./quiz/latam/latam_scoring12";
import latam_scoring22 from "./quiz/latam/latam_scoring22";
import latam_scoring_fwd1 from "./quiz/latam/latam_scoring_fwd1";
import latam_scoring_fwd2 from "./quiz/latam/latam_scoring_fwd2";
import latam_clm_scoring from "./quiz/latam/latam_clm_scoring";
import latam_mxc_scoring from "./quiz/latam/latam_mxc_scoring";
import latam_chl_scoring from "./quiz/latam/latam_chl_scoring";
import latam_arg_scoring from "./quiz/latam/latam_arg_scoring";
import latam_clm_scoring2 from "./quiz/latam/latam_clm_scoring2";
import latam_mxc_scoring2 from "./quiz/latam/latam_mxc_scoring2";
import latam_chl_scoring2 from "./quiz/latam/latam_chl_scoring2";
import latam_arg_scoring2 from "./quiz/latam/latam_arg_scoring2";
import br_scoring1 from "./quiz/brazil/br_scoring1";
import br_scoring_fwd1 from "./quiz/brazil/br_scoring_fwd1";
import br_scoring_fwd2 from "./quiz/brazil/br_scoring_fwd2";
import turkey_math_kids from "./quiz/turkey/turkey_math";
import turkey_math_kids_double from "./quiz/turkey/turkey_math2";
import softtech_coding from "./quiz/turkey/softtech_coding";
import coding_freecourse_turkey from "./quiz/turkey/coding_freecourse_turkey";
import turkey_soft_skills from "./quiz/turkey/soft_skills";
import turkey_soft_skills_2 from "./quiz/turkey/soft_skills_2";
import turkey_math_gtc from "./quiz/turkey/math_gtc";
import turkey_math_1_1 from "./quiz/turkey/math_1_1";
import turkey_longquiz_softskills from "./quiz/turkey/longquiz_softskills";
import tr_sp_math_b from "./quiz/turkey/tr_sp_math_b";
import tr_sp_math_a from "./quiz/turkey/tr_sp_math_a";
import turkey_soft_1_1 from "./quiz/turkey/turkey_soft";
import tr_sp_lgs_a from "./quiz/turkey/tr_sp_lgs_a";
import tr_sp_lgs_b from "./quiz/turkey/tr_sp_lgs_b";
import tr_sp_math_grades from "./quiz/turkey/tr_sp_math_grades";
import tr_sp_math_a_short from "./quiz/turkey/tr_sp_math_a_short";
import tr_content_myths_paid from "./quiz/turkey/tr_content_myths_paid";
import turkey_math_4weeks from "./quiz/turkey/math_4weeks"
import tr_content_myths_smm from "./quiz/turkey/tr_content_myths_smm"
import tr_content_understanding_paid from "./quiz/turkey/tr_content_understanding_paid"
import turkey_mine from "./quiz/turkey/turkey_mine";
import tr_sp_gts_a from "./quiz/turkey/tr_sp_gts_a";
import tr_content_understanding_smm from "./quiz/turkey/tr_content_understanding_smm";
import tr_gts_a from "./quiz/turkey/tr_gts_a";
import tr_gts_b from "./quiz/turkey/tr_gts_b";
import tr_gts_c from "./quiz/turkey/tr_gts_c";
import tr_gts_d from "./quiz/turkey/tr_gts_d";
import tr_fwd from "./quiz/turkey/tr_fwd";
import tr_gts_e from "./quiz/turkey/tr_gts_e";
import tr_gts_f from "./quiz/turkey/tr_gts_f";
import tr_gts_g from "./quiz/turkey/tr_gts_g";
import tr_gts_h from "./quiz/turkey/tr_gts_h";
import tr_gts_i from "./quiz/turkey/tr_gts_i";
import tr_gts_j from "./quiz/turkey/tr_gts_j";
import tr_gts_k from "./quiz/turkey/tr_gts_k";
import tr_gts_l from "./quiz/turkey/tr_gts_l";
import tr_gts_m from "./quiz/turkey/tr_gts_m";
import tr_lgs from "./quiz/turkey/tr_lgs";
import tr_gts_n from "./quiz/turkey/tr_gts_n";
import turkey_profit from "./quiz/turkey/turkey_profit";
import turkey_coding_habilities from "./quiz/turkey/turkey_coding_habilities";
import tr_longquiz_dev from "./quiz/turkey/tr_longquiz_dev";
import tr_sp_gts_a_test from "./quiz/turkey/tr_sp_gts_a_test";
import tr_sp_gts_a_test_v2 from "./quiz/turkey/tr_sp_gts_a_test_v2";
import tr_fwd_offer from "./quiz/turkey/tr_fwd_offer";
import tr_longquiz_fwd from "./quiz/turkey/tr_longquiz_fwd";
import tr_shortquiz_fwd from "./quiz/turkey/tr_shortquiz_fwd";
import tr_shortquiz_dev from "./quiz/turkey/tr_shortquiz_dev";
import tr_fwd_offer_v2 from "./quiz/turkey/tr_fwd_offer_v2";
import tr_fwd_offer_bright from "./quiz/turkey/tr_fwd_offer_bright";
import tr_fwd_offer_dark from "./quiz/turkey/tr_fwd_offer_dark";
import turkey_math_active_2 from "./quiz/turkey/turkey_math_active_2";
import tr_mine_offer from "./quiz/turkey/tr_mine_offer";
import turkey_math_scholarship from "./quiz/turkey/turkey_math_scholarship";
import math_scholarship from "./quiz/turkey/math_scholarship";
import tr_fwd_review from "./quiz/turkey/tr_fwd_review";
import turkey_fwd_start_immediately from "./quiz/turkey/turkey_fwd_start_immediately";
import turkey_galatasarayfuar from "./quiz/turkey/turkey_galatasarayfuar";
import turkey_booking_lp from "./quiz/turkey/turkey_booking_lp";
import tr_math_review from "./quiz/turkey/tr_math_review";
import tr_math_start from "./quiz/turkey/tr_math_start";
import math_hr from "./quiz/turkey/math_hr";
import digital_hr from "./quiz/turkey/digital_hr";
import tr_math_review_fb from "./quiz/turkey/tr_math_review_fb";
import tr_longquiz_dev2 from "./quiz/turkey/tr_longquiz_dev2";
import tr_personalized_quiz_math from "./quiz/turkey/tr_personalized_quiz_math";
import turkey_anime_start_immediatly from "./quiz/turkey/turkey_anime_start_immediatly";
import turkey_talent from "./quiz/turkey/turkey_talent";
import tr_math_review_v2 from "./quiz/turkey/tr_math_review_v2";
import turkey_talent_tugbacaner from "./quiz/turkey/turkey_talent_tugbacaner";
import turkey_talent_hassasanne from "./quiz/turkey/turkey_talent_hassasanne";
import turkey_talent_mimar30 from "./quiz/turkey/turkey_talent_mimar30";
import tr_math_age from "./quiz/turkey/tr_math_age";
//Italy
import coding_freecourse_italy from "./quiz/italy/coding_freecourse";
import coding_freetc_italy from "./quiz/italy/coding_freetc";
import italy_games_1 from "./quiz/italy/games_1";
import italy_steps_1 from "./quiz/italy/steps_1";
import italy_best_cis_copy from "./quiz/italy/best_cis_copy";
import italy_main_1 from "./quiz/italy/main_1";
import italy_dynamic from "./quiz/italy/dynamic";
import italy_free_course from "./quiz/italy/free_course";
import italy_main_2 from "./quiz/italy/main_2";
import italy_fwd from "./quiz/italy/fwd";
import italy_fwd_slot from "./quiz/italy/fwd_slot";
import it_longquiz_fwd from "./quiz/italy/it_longquiz_fwd";
import coding_freetc_latam_up from "./quiz/latam/coding_freetc_latam_up";
import it_quiz_rob from "./quiz/italy/it_quiz_rob";
import it_quiz_mine from "./quiz/italy/it_quiz_mine";
import it_longloc_fwd from "./quiz/italy/it_longloc_fwd";
import it_longloc_fwd_checkbox from "./quiz/italy/it_longloc_fwd_checkbox";
import it_longloc_fwd_slot from "./quiz/italy/it_longloc_fwd_slot";
import it_fwd_loc_short from "./quiz/italy/it_fwd_loc_short";
import it_personalized_quiz_fwd from "./quiz/italy/it_personalized_quiz_fwd";
import it_personalized_quiz_fwd_slot from "./quiz/italy/it_personalized_quiz_fwd_slot";
import italy_fwd_new_pic from "./quiz/italy/fwd_new_pic";
import italy_fwd_new_pic_slot from "./quiz/italy/fwd_new_pic_slot";
import it_longloc_fwd_spidey from "./quiz/italy/it_longloc_fwd_spidey";
import it_longloc_fwd_freetc from "./quiz/italy/it_longloc_fwd_freetc";
import it_free_lesson from "./quiz/italy/it_free_lesson";

//Poland
import fwd_poland from "./quiz/poland/fwd";
import coding_freecourse_poland from "./quiz/poland/coding_freecourse";
import coding_freetc_poland from "./quiz/poland/coding_freetc";
import poland_1 from "./quiz/poland/v1";
import poland_main_1 from "./quiz/poland/main_1";
import poland_fwd_1 from "./quiz/poland/fwd_1";
import poland_social_proof from "./quiz/poland/social_proof";
import poland_dynamic from "./quiz/poland/dynamic";
import poland_yakub_video from "./quiz/poland/yakub_video";
import poland_v2 from "./quiz/poland/v2";
import poland_free_course from "./quiz/poland/free_course";
import poland_free_tc from "./quiz/poland/free_tc";
import poland_free_course_with_new_cover from "./quiz/poland/free_course_with_new_cover";
import poland_free_class from "./quiz/poland/free_class";
import poland_free_course_for_cs from "./quiz/poland/free_course_for_cs";
import poland_live_principal_free_course from "./quiz/poland/live_principal_free_course";
import pl_longquiz_dev from "./quiz/poland/pl_longquiz_dev";
import pl_rob from "./quiz/poland/pl_rob";
import fwd_poland_loc from "./quiz/poland/fwd_poland_loc";
import pl_longquiz_dev2 from "./quiz/poland/pl_longquiz_dev2";
import pl_rob_cover from "./quiz/poland/pl_rob_cover";
import pl_rob_cover_v2 from "./quiz/poland/pl_rob_cover_v2";
import pl_rob_start_immediately from "./quiz/poland/pl_rob_start_immediately";
import pl_personalized_quiz_fwd from "./quiz/poland/pl_personalized_quiz_fwd";
import pl_roblox from "./quiz/poland/pl_roblox";
import pl_roblox_gcc from "./quiz/poland/pl_roblox_gcc";
//Peru
import peru_1 from "./quiz/peru/v1";
import peru_steps_1 from "./quiz/peru/steps_1";
import peru_2 from "./quiz/peru/v2";
import peru_steps_2 from "./quiz/peru/steps_2";
import peru_1_quiz_vs_onepager from "./quiz/peru/v1_quiz_vs_onepager";
import peru_1_start_immediate from "./quiz/peru/peru_1_start_immediate";
import peru_1_new from "./quiz/peru/peru_1_new";
import peru_1_scoring from "./quiz/peru/peru_1_scoring";
import peru_1_tt from "./quiz/peru/peru_1_tt";
//Latam
import latam_scoring from "./quiz/latam/test_thank_page";
import mexico_fwd from "./quiz/latam/mexico_fwd_as_ind_dc";
import latam_free_course from "./quiz/latam/free_course";
import latam_game_dev from "./quiz/latam/game_dev";
import latam_roblox from "./quiz/latam/roblox";
import latam_social_proof from "./quiz/latam/social_proof";
import latam_roblox_2 from "./quiz/latam/roblox_2";
import latam_hasta_1_mes_gratis from "./quiz/latam/hasta_1_mes_gratis";
import latam_product_roblox_quiz from "./quiz/latam/product_roblox_quiz";
import latam_roblox_custom from "./quiz/latam/roblox_custom";
import latam_roblox2 from "./quiz/latam/roblox2";
import latam_roblox2_2 from "./quiz/latam/roblox2_2";
import latam_limited_offer from "./quiz/latam/limited_offer";
import latam_chile_ab_tool from "./quiz/latam/chile_ab_tool";
import latam_custom_1 from "./quiz/latam/custom_1";
import latam_free_course_social_proof from "./quiz/latam/free_course_social_proof";
import latam_fwd from "./quiz/latam/fwd";
import latam_fwd_checkbox from "./quiz/latam/latam_fwd_checkbox";
import latam_for_google_ads from "./quiz/latam/for_google_ads";
import latam_main from "./quiz/latam/main";
import latam_5_7_kid from "./quiz/latam/5_7_kid";
import latam_for_google_ads2 from "./quiz/latam/for_google_ads2";
import latam_early_math from "./quiz/latam/early_math";
import latam_early_math_new_design from "./quiz/latam/early_math_new_design";
import es_nocover from "./quiz/latam/es_nocover";
import latam_internship from "./quiz/latam/internship";
import coding_freetc_latam from "./quiz/latam/coding_freetc_latam";
import math_freetc_latam from "./quiz/latam/math_freetc_latam";
import fwd_freetc_latam from "./quiz/latam/fwd_freetc_latam";
import es_content_myths_paid from "./quiz/latam/es_content_myths_paid";
import es_content_understanding_paid from "./quiz/latam/es_content_understanding_paid";
import sp_longquiz_dev from "./quiz/latam/sp_longquiz_dev";
import es_content_myths_smm from "./quiz/latam/es_content_myths_smm";
import coding_freetc_latam_up_google from "./quiz/latam/coding_freetc_latam_up_google";
import math_freetc_latam_new from "./quiz/latam/math_freetc_latam_new";
import latam_fwd_tab from "./quiz/latam/latam_fwd_tab";
import latam_fwd_px from "./quiz/latam/latam_fwd_px";
import math_freetc_latam_long from "./quiz/latam/math_freetc_latam_long";
import latam_scoring_google from "./quiz/latam/latam_scoring_google";
import latam_scoring_meta from "./quiz/latam/latam_scoring_meta";
import spain_freetc from "./quiz/latam/spain_freetc";
import latam_coding_habilities from "./quiz/latam/latam_coding_habilities";
import es_content_distraction_paid from "./quiz/latam/es_content_distraction_paid";
import es_content_stress_paid from "./quiz/latam/es_content_stress_paid";
import es_content_future_job from "./quiz/latam/es_content_future_job";
import es_content_tired_paid from "./quiz/latam/es_content_tired_paid";
import latam_scoring_google_test from "./quiz/latam/latam_scoring_google_test";
import latam_scoring_meta_test from "./quiz/latam/latam_scoring_meta_test";
import latam_fwd_tab_new from "./quiz/latam/latam_fwd_tab_new";
import latam_design from "./quiz/latam/latam_design";
import latam_hpc from "./quiz/latam/latam_hpc";
import latam_design_quiz_vs_commonpage from "./quiz/latam/latam_design_quiz_vs_commonpage";
import latam_profit from "./quiz/latam/latam_profit";
import latam_profit_checkbox from "./quiz/latam/latam_profit_checkbox";
import latam_future from "./quiz/latam/latam_future";
import latam_mine from "./quiz/latam/latam_mine";
import latam_scoring_google_2 from "./quiz/latam/latam_scoring_google_2";
import spain_free_course from "./quiz/latam/spain_free_course";
import spain_free_course_slot from "./quiz/latam/spain_free_course_slot";
import spain_free_course_checkbox from "./quiz/latam/spain_free_course_checkbox";
import spain_free_course_gcc from "./quiz/latam/spain_free_course_gcc";
import spain_scoring1 from "./quiz/latam/spain_scoring1";
import latam_5_7_kid_new from "./quiz/latam/5_7_kid_new";
import sp_longquiz_dev_timer from "./quiz/latam/sp_longquiz_dev_timer";
import latam_music from "./quiz/latam/latam_music";
import latam_photo from "./quiz/latam/latam_photo";
import latam_singing from "./quiz/latam/latam_singing";
import latam_illustration from "./quiz/latam/latam_illustration";
import latam_animation from "./quiz/latam/latam_animation";
import latam_music_kids from "./quiz/latam/latam_music_kids";
import latam_drawing_kids from "./quiz/latam/latam_drawing_kids";
import latam_roblox_new from "./quiz/latam/latam_roblox";
import es_freecourse from "./quiz/latam/es_freecourse";
import latam_5_7_kid_start_immediatly from "./quiz/latam/5_7_kid_start_immediatly";
import latam_fwd_start_immediately from "./quiz/latam/latam_fwd_start_immediately";
import latam_fwd_scoring from "./quiz/latam/latam_fwd_scoring";
import latam_5_7_kid_new_scoring from "./quiz/latam/5_7_kid_new_scoring";
import latam_free_course_social_proof_step_offers from "./quiz/latam/free_course_social_proof_step_offers";
import latam_social_proof_step_offers from "./quiz/latam/social_proof_step_offers";
import latam_profit_career from "./quiz/latam/latam_profit_career";
import latam_profit_money from "./quiz/latam/latam_profit_money";
import latam_profit_school_gap_career from "./quiz/latam/latam_profit_school_gap_career";
import latam_profit_school_gap_skills from "./quiz/latam/latam_profit_school_gap_skills";
import latam_profit_skills from "./quiz/latam/latam_profit_skills";
import spain_freetc_5_euro from "./quiz/latam/spain_freetc_5_euro";
import latam_coding_10 from "./quiz/latam/latam_coding_10";
import scholarship_3millones from "./quiz/latam/scholarship_3-millones";
import scholarship_mxn from "./quiz/latam/scholarship_mxn";
//CIS
import cis_free_course from "./quiz/cis/free_course";
import coding_freecourse_cis from "./quiz/cis/coding_freecourse_cis"
import cis_fwd from "./quiz/cis/cis_fwd"
import cis_it from "./quiz/cis/cis_it";
import cis_it_prof from "./quiz/cis/cis_it_prof";
import cis_it2 from "./quiz/cis/cis_it2";
import cis_it_prof2 from "./quiz/cis/cis_it_prof2";
import cis_math from "./quiz/cis/cis_math";
//UK
import uk_freeclass from "./quiz/uk/freeclass";
import uk_freeclass2 from "./quiz/uk/freeclass2";
import uk_test from "./quiz/uk/freeclassTest";
import uk_mine from "./quiz/uk/mine";
import uk_class from "./quiz/uk/class";
import uk_class2 from "./quiz/uk/class2";
import uk_longquiz_dev from "./quiz/uk/uk_longquiz_dev";
import uk_fwd from "./quiz/uk/uk_fwd";
import uk_roblox from "./quiz/uk/uk_roblox";
import uk_media from "./quiz/uk/uk_media";
import uk_personalized_quiz_fwd from "./quiz/uk/uk_personalized_quiz_fwd";

//USA
import usa_fwd from "./quiz/usa/usa_fwd";
import usa_roblox from "./quiz/usa/usa_roblox";
import usa_media from "./quiz/usa/usa_media";
import usa_personalized_quiz_fwd from "./quiz/usa/usa_personalized_quiz_fwd";

//BRAZIL
import br_longquiz_dev from "./quiz/brazil/longquiz_dev";
import coding_freetc_brazil from "./quiz/brazil/coding_freetc_brazil";
import coding_freetc_brazil_google from "./quiz/brazil/coding_freetc_brazil_google";
import brazil_scoring_google from "./quiz/brazil/brazil_scoring_google";
import brazil_scoring_google_short from "./quiz/brazil/brazil_scoring_google_short";
import fwd_freetc_br from "./quiz/brazil/fwd_freetc_br";
import br_longquiz_dev_2 from "./quiz/brazil/br_longquiz_dev_2";
import coding_freetc_brazil_quiz_vs_onepager from "./quiz/brazil/coding_freetc_brazil_quiz_vs_onepager";
import br_quiz_dev_short from "./quiz/brazil/br_quiz_dev_short";
import br_mine from "./quiz/brazil/br_mine";
import br_personalized_quiz_dev_short from "./quiz/brazil/br_personalized_quiz_dev_short";
import br_profit_career from "./quiz/brazil/br_profit_career";
import br_profit_money from "./quiz/brazil/br_profit_money";
import br_profit_skills from "./quiz/brazil/br_profit_skills";
import brazil_talent_gabi30 from "./quiz/brazil/brazil_talent_gabi30";
import brazil_talent_eloane30 from "./quiz/brazil/brazil_talent_eloane30";
import brazil_talent_sarah30 from "./quiz/brazil/brazil_talent_sarah30";

//UAE
import uae_freeclass from "./quiz/uae/uae_freeclass";

//Arabic
import coding_gcc from "./quiz/arabic/coding_gcc";

//Spain
import spain_design from "./quiz/spain/spain_design";
import spain_design_slot from "./quiz/spain/spain_design_slot";
import spain_roblox_new from "./quiz/spain/spain_roblox_new";
import spain_start_immediate from "./quiz/spain/spain_start_immediate";
import spain_roblox_freecourse from "./quiz/spain/spain_roblox_freecourse";
import spain_roblox_freecourse_slot from "./quiz/spain/spain_roblox_freecourse_slot";
import spain_coding_freecourse from "./quiz/spain/spain_coding_freecourse";

export default {
  "scholarship_3-millones": scholarship_3millones,
  scholarship_mxn,
  tr_math_age,
  uk_test,
  uk_freeclass,
  uk_freeclass2,
  turkey_math_kids,
  indonesia_yellow,
  indonesia_purple,
  indonesia_green,
  testing_quiz_only,
  testing_with_autobooking,
  indonezia_v1,
  indo_dc_1,
  indo_steps_dc_1,
  indo_steps_dc_2,
  indo_steps_dc_3,
  indo_coding_1,
  indo_coding_2,
  indo_coding_2_eng,
  indo_zp_1,
  indo_base_1,
  indo_base_1_gcc,
  indo_bf_dc,
  indo_crossed_price_1,
  indo_leadmagnet_1,
  indo_dc_comp_1,
  indo_dc_base_bonus,
  indo_new_year,
  indo_bonus_coding_3,
  indo_certificate_dc,
  indo_coding_4,
  indo_give_away,
  indo_computer_literacy,
  indo_without_questions,
  indo_course,
  indo_social_proof,
  indo_crossed_price_2,
  indo_coding_2_2,
  indo_v2,
  indo_custom_start_screen,
  indo_v3,
  indo_limited_offer,
  indo_custom_profi,
  indo_free_course,
  indo_free_course_dc,
  indo_teens,
  indo_early_math,
  indo_graphic_design,
  tr_roblox,
  turkey_1,
  turkey_math,
  turkey_dc_2,
  turkey_dc_1,
  turkey_steps_1,
  turkey_bf_steps_1,
  turkey_steps_28_11,
  turkey_crossed_1,
  turkey_bloggers_1,
  turkey_coding_steps,
  turkey_new_year_steps,
  turkey_coding_steps_new,
  turkey_bonus_steps_1,
  turkey_universal,
  turkey_gaming,
  turkey_social_proof_steps,
  turkey_capi_1,
  turkey_steps_bonus_picture,
  turkey_bloggers_2,
  turkey_coding_steps_2,
  turkey_steps_2,
  turkey_customized_lp,
  turkey_customized_lp_age,
  turkey_teenagers,
  turkey_limited_offer,
  turkey_b2b,
  turkey_softtech,
  turkey_screening_lesson,
  turkey_free_marathon,
  turkey_gamedev_free_course,
  turkey_free_course_social_proof,
  turkey_free_course,
  turkey_parent_or_child,
  turkey_europe,
  turkey_live_free_course,
  turkey_b2b_ako,
  turkey_b2b_bil_kurs,
  turkey_gamedev_free_course_2,
  turkey_b2b_kocailem,
  turkey_b2b_isbankasi,
  turkey_b2b_lc_waikiki,
  turkey_b2b_aguniversity,
  turkey_first_money_in_it,
  turkey_math_active,
  turkey_socialproof,
  turkey_supermega_social_proof,
  turkey_b2b_girne_college,
  turkey_b2b_savdes,
  turkey_one_year_gift,
  turkey_one_year_gift_2,
  turkey_free_course_2,
  turkey_coding_steps2,
  turkey_mentorship,
  turkey_webinar,
  italy_games_1,
  italy_steps_1,
  italy_best_cis_copy,
  italy_main_1,
  italy_dynamic,
  italy_free_course,
  italy_main_2,
  poland_1,
  poland_main_1,
  poland_fwd_1,
  poland_social_proof,
  poland_dynamic,
  poland_yakub_video,
  poland_v2,
  poland_free_course,
  poland_free_tc,
  poland_free_course_with_new_cover,
  poland_free_class,
  poland_free_course_for_cs,
  poland_live_principal_free_course,
  peru_1,
  peru_steps_1,
  peru_2,
  peru_steps_2,
  mexico_fwd,
  latam_free_course,
  latam_game_dev,
  latam_roblox,
  latam_social_proof,
  latam_roblox_2,
  latam_hasta_1_mes_gratis,
  latam_product_roblox_quiz,
  latam_roblox_custom,
  latam_roblox2,
  latam_roblox2_2,
  latam_limited_offer,
  latam_chile_ab_tool,
  latam_custom_1,
  latam_free_course_social_proof,
  latam_fwd,
  latam_fwd_checkbox,
  latam_for_google_ads,
  latam_main,
  latam_5_7_kid,
  latam_for_google_ads2,
  latam_early_math,
  latam_internship,
  latam_scoring,
  cis_free_course,
  latam_early_math_new_design,
  es_nocover,
  turkey_scoring,
  tr_scoring1,
  tr_scoring2,
  tr_math_scoring1,
  latam_scoring1,
  lead_scor,
  lead_no_scor,
  lead_scor_1,
  lead_no_scor_2,
  latam_scoring2,
  latam_scoring3,
  latam_scoring12,
  latam_scoring22,
  latam_scoring_fwd1,
  latam_scoring_fwd2,
  latam_clm_scoring,
  latam_mxc_scoring,
  latam_chl_scoring,
  latam_arg_scoring,
  latam_clm_scoring2,
  latam_mxc_scoring2,
  latam_chl_scoring2,
  latam_arg_scoring2,
  br_scoring1,
  br_scoring_fwd1,
  br_scoring_fwd2,
  coding_freetc_poland,
  coding_freetc_italy,
  coding_freecourse_poland,
  coding_freecourse_italy,
  softtech_math,
  softtech_coding,
  turkey_math_kids_double,
  coding_freecourse_turkey,
  coding_freetc_latam,
  math_freetc_latam,
  math_freetc_indonesia,
  math_freetc_indonesia_gcc,
  turkey_soft_skills,
  turkey_soft_skills_2,
  turkey_math_gtc,
  turkey_math_1_1,
  fwd_freetc_latam,
  coding_freecourse_cis,
  fwd_poland,
  turkey_longquiz_softskills,
  italy_fwd,
  italy_fwd_slot,
  tr_sp_math_b,
  tr_sp_math_a,
  turkey_soft_1_1,
  br_longquiz_dev,
  tr_sp_lgs_a,
  tr_sp_lgs_b,
  turkey_math_active2,
  pl_longquiz_dev,
  it_longquiz_fwd,
  tr_sp_math_grades,
  tr_sp_math_a_short,
  es_content_myths_paid,
  tr_content_myths_paid,
  cis_fwd,
  pl_rob,
  math_freetc_indonesia_new,
  math_freetc_indonesia_new_checkbox,
  math_freetc_indonesia_new_intent,
  tr_content_myths_smm,
  indo_fwd,
  es_content_understanding_paid,
  tr_content_understanding_paid,
  sp_longquiz_dev,
  turkey_mine,
  tr_sp_gts_a,
  tr_content_understanding_smm,
  coding_freetc_latam_up,
  coding_freetc_brazil,
  my_base,
  my_fwd,
  es_content_myths_smm,
  coding_freetc_brazil_google,
  coding_freetc_latam_up_google,
  math_freetc_latam_new,
  it_quiz_mine,
  it_quiz_rob,
  latam_fwd_tab,
  fwd_poland_loc,
  it_longloc_fwd,
  it_longloc_fwd_checkbox,
  it_longloc_fwd_slot,
  latam_fwd_px,
  math_freetc_latam_long,
  pl_longquiz_dev2,
  tr_gts_a,
  tr_gts_b,
  tr_gts_c,
  tr_gts_d,
  tr_fwd,
  latam_scoring_google,
  latam_scoring_meta,
  tr_gts_e,
  tr_gts_f,
  uae_freeclass,
  tr_gts_g,
  tr_gts_h,
  tr_gts_i,
  uk_mine,
  tr_gts_j,
  tr_gts_k,
  tr_gts_l,
  tr_gts_m,
  tr_lgs,
  tr_gts_n,
  turkey_profit,
  uk_class,
  uk_class2,
  spain_freetc,
  latam_coding_habilities,
  es_content_distraction_paid,
  turkey_coding_habilities,
  es_content_stress_paid,
  es_content_future_job,
  es_content_tired_paid,
  math_freetc_indonesia_pix,
  brazil_scoring_google,
  latam_scoring_google_test,
  latam_scoring_meta_test,
  cis_it,
  cis_it_prof,
  latam_fwd_tab_new,
  latam_design,
  cis_it2,
  cis_it_prof2,
  brazil_scoring_google_short,
  latam_hpc,
  it_fwd_loc_short,
  it_personalized_quiz_fwd,
  it_personalized_quiz_fwd_slot,
  indonesia_longquiz_dev,
  indonesia_longquiz_rob,
  tr_longquiz_dev,
  uk_longquiz_dev,
  fwd_freetc_br,
  br_longquiz_dev_2,
  coding_freetc_brazil_quiz_vs_onepager,
  peru_1_quiz_vs_onepager,
  tr_sp_gts_a_test,
  cis_math,
  latam_design_quiz_vs_commonpage,
  tr_sp_gts_a_test_v2,
  br_quiz_dev_short,
  latam_profit,
  latam_profit_checkbox,
  latam_future,
  latam_mine,
  br_mine,
  tr_fwd_offer,
  tr_longquiz_fwd,
  latam_scoring_google_2,
  spain_free_course,
  spain_free_course_slot,
  spain_free_course_checkbox,
  spain_free_course_gcc,
  spain_scoring1,
  latam_5_7_kid_new,
  peru_1_start_immediate,
  tr_shortquiz_fwd,
  tr_shortquiz_dev,
  peru_1_new,
  tr_fwd_offer_v2,
  tr_fwd_offer_bright,
  tr_fwd_offer_dark,
  turkey_math_4weeks,
  turkey_math_active_2,
  tr_mine_offer,
  sp_longquiz_dev_timer,
  turkey_math_scholarship,
  math_scholarship,
  br_personalized_quiz_dev_short,
  tr_fwd_review,
  turkey_fwd_start_immediately,
  turkey_galatasarayfuar,
  indonesia_course,
  indonesia_offer,
  latam_music,
  latam_photo,
  latam_singing,
  latam_illustration,
  latam_animation,
  latam_music_kids,
  latam_drawing_kids,
  turkey_booking_lp,
  tr_math_review,
  latam_roblox_new,
  tr_math_start,
  math_hr,
  digital_hr,
  tr_math_review_fb,
  es_freecourse,
  testing_cover_question,
  latam_5_7_kid_start_immediatly,
  latam_fwd_start_immediately,
  latam_fwd_scoring,
  peru_1_scoring,
  peru_1_tt,
  latam_5_7_kid_new_scoring,
  pl_rob_cover,
  pl_rob_cover_v2,
  pl_rob_start_immediately,
  latam_free_course_social_proof_step_offers,
  latam_social_proof_step_offers,
  tr_longquiz_dev2,
  tr_personalized_quiz_math,
  br_profit_career,
  br_profit_money,
  br_profit_skills,
  latam_profit_career,
  latam_profit_money,
  latam_profit_school_gap_career,
  latam_profit_school_gap_skills,
  latam_profit_skills,
  in_fwd,
  indonesia_longquiz_fwd,
  indonesia_fwd,
  indonesia_video,
  indo_profit,
  indo_profit_gcc,
  spain_freetc_5_euro,
  coding_gcc,
  turkey_anime_start_immediatly,
  turkey_talent,
  latam_coding_10,
  tr_math_review_v2,
  turkey_talent_tugbacaner,
  turkey_talent_hassasanne,
  brazil_talent_gabi30,
  brazil_talent_eloane30,
  italy_fwd_new_pic,
  italy_fwd_new_pic_slot,
  brazil_talent_sarah30,
  pl_personalized_quiz_fwd,
  pl_roblox,
  pl_roblox_gcc,
  turkey_talent_mimar30,
  it_longloc_fwd_spidey,
  it_longloc_fwd_freetc,
  it_free_lesson,
  uk_fwd,
  uk_roblox,
  uk_media,
  uk_personalized_quiz_fwd,
  usa_fwd,
  usa_roblox,
  usa_media,
  usa_personalized_quiz_fwd,
  spain_design,
  spain_design_slot,
  spain_roblox_new,
  spain_start_immediate,
  spain_roblox_freecourse,
  spain_roblox_freecourse_slot,
  spain_coding_freecourse,
};
